/**
 * @generated SignedSource<<2139ef75bc9f6b96eafb38f78972c7bd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BuyerShipmentRequest_deliveryOptions$data = ReadonlyArray<{
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutShipmentNotes_deliveryOptions">;
  readonly " $fragmentType": "BuyerShipmentRequest_deliveryOptions";
}>;
export type BuyerShipmentRequest_deliveryOptions$key = ReadonlyArray<{
  readonly " $data"?: BuyerShipmentRequest_deliveryOptions$data;
  readonly " $fragmentSpreads": FragmentRefs<"BuyerShipmentRequest_deliveryOptions">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "BuyerShipmentRequest_deliveryOptions",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutShipmentNotes_deliveryOptions"
    }
  ],
  "type": "ShipmentQuote",
  "abstractKey": null
};

(node as any).hash = "d2ceff4ca67fd68a0c7f7722f71296f2";

export default node;
